// The redesign is built into the app but switched on only where REACT_APP_REDESIGN=1 at build time (the dev website).
// Live is built without it, so customers keep today's design until the whole redesign is ready.
export const isRedesign = () => process.env.REACT_APP_REDESIGN === '1';
